import { useEffect, useRef } from 'react';

const useExecuteOnce = (callback: () => void, condition: boolean = true) => {
  const hasExecuted = useRef(false);

  useEffect(() => {
    if (!hasExecuted.current && condition) {
      callback();
      hasExecuted.current = true;
    }
  }, [callback, condition]);
};

export { useExecuteOnce };
